"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimeDuration = exports.createVoidHandler = exports.fireAndForgetWrapper = exports.getDeviceInfoFromUserAgent = exports.logNodeOnly = exports.logInspect = exports.isRunningInNode = exports.partitionArray = exports.walkObjectTree = exports.deepRightDiff = exports.defaultDeepMergeOptions = exports.deepMerge = exports.deepClone = exports.deepEquals = exports.safeStableStringify = exports.omitKeys = exports.pickKeys = exports.pushToArrayAttribute = exports.deleteNullishProperties = exports.deletePropertiesIfNullishOrEmpty = exports.deletePropertyIfNullishOrEmpty = exports.deletePropertyIfEquals = exports.deletePropertyIf = exports.setPropertyIfUndefined = exports.assertDefinedAndReturn = exports.assertDefined = exports.nullsToUndefineds = exports.nullToUndefined = exports.invokeWithTimeout = exports.msleep = exports.isPositiveInteger = exports.swallowErrors = exports.die = void 0;
/* eslint-disable curly,no-null/no-null,@typescript-eslint/no-empty-function,no-prototype-builtins */
const assert_1 = __importDefault(require("assert"));
const deepmerge_1 = __importDefault(require("deepmerge"));
const device_detector_js_1 = __importDefault(require("device-detector-js"));
const fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
const lodash_1 = __importDefault(require("lodash"));
const safe_stable_stringify_1 = require("safe-stable-stringify");
const util_1 = require("util");
const Duration_1 = require("./Duration");
const ZonedDateTime_1 = require("./ZonedDateTime");
/**
 * Convenience function that may be used as doSmth() || die().
 */
function die(msg = "unexpected") {
    throw new Error(msg);
}
exports.die = die;
/**
 * Convenience function to invoke a function, catch potential errors, and return a custom value of the same
 * return type if an error is caught.
 */
function swallowErrors(fun, ret) {
    try {
        return fun();
    }
    catch (err) {
        return typeof ret === "function" ? ret(err) : ret;
    }
}
exports.swallowErrors = swallowErrors;
/**
 * Test if a string or number represents a valid positive (or strictly positive) integer.
 */
function isPositiveInteger(arg, strictlyPositive = false) {
    const n = Math.floor(Number(arg !== null && arg !== void 0 ? arg : -1));
    if (n === Infinity && isNaN(n) && String(n) !== String(arg)) {
        return false;
    }
    return strictlyPositive ? n > 0 : n >= 0;
}
exports.isPositiveInteger = isPositiveInteger;
/**
 * Sleep.
 */
function msleep(ms) {
    return __awaiter(this, void 0, void 0, function* () {
        const converted = ms instanceof Duration_1.Duration ? ms.asMilliseconds() : ms;
        return new Promise((resolve) => setTimeout(resolve, converted));
    });
}
exports.msleep = msleep;
/**
 * Timeout detection helper. Throws in case of timeout.
 */
function invokeWithTimeout(ms, promise, activityName) {
    return __awaiter(this, void 0, void 0, function* () {
        let timeout = false;
        const timeoutDetector = (ms) => __awaiter(this, void 0, void 0, function* () {
            yield msleep(ms);
            timeout = true;
        });
        const res = yield Promise.race([timeoutDetector(ms), promise]);
        if (timeout) {
            const msg = "Timeout detected" + (activityName ? ` ${activityName}` : "");
            throw new Error(msg);
        }
        return res;
    });
}
exports.invokeWithTimeout = invokeWithTimeout;
/**
 * Change null to undefined.
 */
function nullToUndefined(v) {
    return v === null ? undefined : v;
}
exports.nullToUndefined = nullToUndefined;
/**
 * Change null attributes to undefined.
 */
function nullsToUndefineds(obj) {
    assertDefined(obj);
    return Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, nullToUndefined(v)]));
}
exports.nullsToUndefineds = nullsToUndefineds;
/**
 * Assert helper.
 */
function assertDefined(val, errMsg) {
    const ok = val !== undefined && val !== null;
    if (!ok && errMsg && isRunningInNode()) {
        const msg = errMsg ? `"${typeof errMsg === "string" ? errMsg : errMsg()}"` : "<blank>";
        logNodeOnly(`assertDefined() failed (msg=${msg})`);
    }
    assert_1.default.ok(ok);
}
exports.assertDefined = assertDefined;
/**
 * Assert and return helper.
 */
function assertDefinedAndReturn(val, errMsg) {
    assertDefined(val, errMsg);
    return val;
}
exports.assertDefinedAndReturn = assertDefinedAndReturn;
/**
 * Sets an object property if undefined.
 */
function setPropertyIfUndefined(obj, key, val) {
    //ideally, should return: asserts obj is Omit<T, K> & Partial<Pick<T, K>>
    assertDefined(val);
    if (obj[key] === undefined) {
        obj[key] = val;
    }
}
exports.setPropertyIfUndefined = setPropertyIfUndefined;
/**
 * Delete an object's attribute if its value satisfies a predicate.
 */
function deletePropertyIf(obj, key, cond) {
    const v = obj[key];
    if (v !== undefined && cond(v)) {
        delete obj[key];
    }
}
exports.deletePropertyIf = deletePropertyIf;
function deletePropertyIfEquals(obj, key, v) {
    deletePropertyIf(obj, key, (current) => current === v);
}
exports.deletePropertyIfEquals = deletePropertyIfEquals;
function deletePropertyIfNullishOrEmpty(obj, key) {
    deletePropertyIf(obj, key, (current) => !current ||
        (Array.isArray(current) && !current.length) ||
        (typeof current === "object" && !Object.keys(current).length));
}
exports.deletePropertyIfNullishOrEmpty = deletePropertyIfNullishOrEmpty;
function deletePropertiesIfNullishOrEmpty(obj, keys) {
    keys.forEach((key) => deletePropertyIfNullishOrEmpty(obj, key));
}
exports.deletePropertiesIfNullishOrEmpty = deletePropertiesIfNullishOrEmpty;
/**
 * Removes all keys that have null or undefined (nullish) values.
 * Unlike `deletePropertiesIfNullishOrEmpty`, the return type is preserved.
 * @example
 *   const result = deleteNullishProperties({a: 1, b: false, c: undefined });
 *   // result: { a: 1, b: false }
 */
const deleteNullishProperties = (obj) => lodash_1.default.omitBy(obj, lodash_1.default.isNil.bind(lodash_1.default));
exports.deleteNullishProperties = deleteNullishProperties;
/**
 * Appends a value to an array attribute of an object.
 * If this attribute is undefined, properly initializes the array first.
 */
function pushToArrayAttribute(obj, k, v) {
    var _a;
    if (!(k in obj)) {
        obj[k] = [];
    }
    (_a = obj[k]) === null || _a === void 0 ? void 0 : _a.push(v);
}
exports.pushToArrayAttribute = pushToArrayAttribute;
/**
 * Keep only certain attributes by keys from an object. Leaves the input object unchanged.
 */
function pickKeys(obj, keys) {
    assert_1.default.ok(!Array.isArray(obj));
    const ret = {};
    for (const k of Array.isArray(keys) ? keys : [keys]) {
        ret[k] = obj[k];
    }
    return ret;
}
exports.pickKeys = pickKeys;
/**
 * Remove attributes by keys from an object. Leaves the input object unchanged.
 */
function omitKeys(obj, keys) {
    assert_1.default.ok(!Array.isArray(obj));
    obj = Object.assign({}, obj);
    for (const k of Array.isArray(keys) ? keys : [keys]) {
        delete obj[k];
    }
    return obj;
}
exports.omitKeys = omitKeys;
/**
 * Stable stringification helper.
 */
function safeStableStringify(obj) {
    var _a;
    return (_a = (0, safe_stable_stringify_1.stringify)(obj)) !== null && _a !== void 0 ? _a : "{}";
}
exports.safeStableStringify = safeStableStringify;
/**
 * Deep, strict equality helper. Supports undefined and null in both arguments.
 * NB: undefined === undefined, null === null, undefined !== null)
 */
function deepEquals(a, b) {
    return (0, fast_deep_equal_1.default)(a, b);
}
exports.deepEquals = deepEquals;
/**
 * Deep cloning helper.
 * Supports all primitive types and instances of classes.
 */
function deepClone(obj) {
    return obj ? lodash_1.default.cloneDeep(obj) : obj;
}
exports.deepClone = deepClone;
/**
 * Deep merging helper. Precedence increases with array index.
 */
function deepMerge(objs, options) {
    const nonNilObjs = objs.filter(Boolean);
    return deepmerge_1.default.all(nonNilObjs, Object.assign(Object.assign({}, exports.defaultDeepMergeOptions), options));
}
exports.deepMerge = deepMerge;
exports.defaultDeepMergeOptions = {
    isMergeableObject: (v) => {
        const ctor = v === null || v === void 0 ? void 0 : v.constructor;
        return ctor === Object; // || ctor === undefined || ctor === Boolean || ctor === String || ctor === Number || ctor === Array
    },
};
/**
 * Deep diff helper.
 * Finds and outputs changes that are present in right compared to left.
 * Undefined attributes in right are not considered differences.
 */
function deepRightDiff(left, right) {
    var _a;
    const helper = (left, right) => {
        if (deepEquals(left, right)) {
            return undefined;
        }
        if (typeof left !== "object" || typeof right !== "object" || left === null || right === null) {
            return right;
        }
        if (Array.isArray(right)) {
            return right;
        }
        let ret;
        for (const k in left) {
            const tmp = helper(left[k], right[k]);
            if (tmp !== undefined) {
                (ret !== null && ret !== void 0 ? ret : (ret = {}))[k] = tmp;
            }
        }
        for (const k in right) {
            if (!(k in left)) {
                (ret !== null && ret !== void 0 ? ret : (ret = {}))[k] = right[k];
            }
        }
        return ret;
    };
    const ret = helper(left, right);
    return (_a = ret) !== null && _a !== void 0 ? _a : {};
}
exports.deepRightDiff = deepRightDiff;
/**
 * Walk down an object tree recursively. Does all potential transforms in-place.
 * Returns an object, in case the root itself got replaced or clobbered.
 */
function walkObjectTree(root, userWalkFun, ownPropertiesOnly = true) {
    let maxSteps = 10000000;
    const internalWalkFun = (it, parent, keyInParent) => {
        assert_1.default.ok(--maxSteps > 0, "walkObjectTree: object too large");
        const userRes = userWalkFun(it, parent, keyInParent);
        if ((userRes === null || userRes === void 0 ? void 0 : userRes.dropKey) || (userRes === null || userRes === void 0 ? void 0 : userRes.replacementKey) !== undefined || (userRes === null || userRes === void 0 ? void 0 : userRes.replacementValue) !== undefined) {
            return {
                key: keyInParent !== null && keyInParent !== void 0 ? keyInParent : "dummyKey",
                replacementKey: userRes.replacementKey,
                replacementValue: userRes.replacementValue,
            };
        }
        if ((userRes === null || userRes === void 0 ? void 0 : userRes.skipVisit) || it === null || ["undefined", "number", "boolean", "string"].includes(typeof it)) {
            return undefined;
        }
        const changes = [];
        if (Array.isArray(it)) {
            const arr = it;
            for (let i = 0; i < arr.length; i++) {
                const internalRes = internalWalkFun(arr[i], arr, i);
                if (internalRes)
                    changes.push(internalRes);
            }
            let deleteCount = 0;
            for (const change of changes) {
                assert_1.default.ok(change.replacementKey === undefined, "walkObjectTree: cannot move array elements");
                if (change.replacementValue !== undefined) {
                    arr[change.key - deleteCount] = change.replacementValue;
                }
                else {
                    for (let j = change.key - deleteCount; j < arr.length - 1; j++)
                        arr[j] = arr[j + 1];
                    arr.pop();
                    deleteCount++;
                }
            }
        }
        else {
            const obj = it;
            for (const k in obj) {
                if (ownPropertiesOnly && !obj.hasOwnProperty(k))
                    continue;
                const internalRes = internalWalkFun(obj[k], obj, k);
                if (internalRes)
                    changes.push(internalRes);
            }
            for (const change of changes) {
                if (change.replacementKey !== undefined) {
                    obj[change.replacementKey] =
                        change.replacementValue !== undefined ? change.replacementValue : obj[change.key];
                    delete obj[change.key];
                }
                else if (change.replacementValue !== undefined) {
                    obj[change.key] = change.replacementValue;
                }
                else {
                    delete obj[change.key];
                }
            }
        }
        return undefined;
    };
    const rootChange = internalWalkFun(root);
    assert_1.default.ok(!(rootChange === null || rootChange === void 0 ? void 0 : rootChange.replacementKey), "walkObjectTree: cannot replace root key");
    if ((rootChange === null || rootChange === void 0 ? void 0 : rootChange.replacementValue) !== undefined)
        return rootChange.replacementValue;
    if (rootChange === null || rootChange === void 0 ? void 0 : rootChange.key)
        return undefined;
    return root;
}
exports.walkObjectTree = walkObjectTree;
/**
 * Partitions an array. Output subarrays are never empty.
 */
function partitionArray(input, size, mode) {
    switch (mode) {
        case "max_element_count":
            return partitionArray(input, size > 0 ? Math.ceil(input.length / size) : 1, "target_partition_count");
        case "target_partition_count":
            return partitionArray(input, size > 0 ? Math.ceil(input.length / size) : input.length, "exact_element_count");
        case "exact_element_count": {
            const ret = [];
            for (let i = 0;; i += size) {
                const s = input.slice(i, i + size);
                if (s.length === 0) {
                    break;
                }
                ret.push(s);
            }
            return ret;
        }
    }
}
exports.partitionArray = partitionArray;
/**
 * Detected whether the script is running in node.
 */
let isRunningInNodeCached;
function isRunningInNode() {
    var _a;
    if (isRunningInNodeCached === undefined) {
        isRunningInNodeCached =
            typeof ((_a = process === null || process === void 0 ? void 0 : process.release) === null || _a === void 0 ? void 0 : _a.name) === "string" && process.release.name.search(/node|io.js/) !== -1;
    }
    return isRunningInNodeCached;
}
exports.isRunningInNode = isRunningInNode;
let logNodeOnlyLogger;
/**
 * Log using js inspect.
 */
function logInspect(obj, depth = 5, colors = true) {
    console.log((0, util_1.inspect)(obj, { compact: true, depth, colors }));
}
exports.logInspect = logInspect;
/**
 * Emits a console.log only if running in Node.js. Useful to log from frontend-backend shared code.
 */
function logNodeOnly(msg, options) {
    var _a;
    if (isRunningInNode()) {
        msg = typeof msg === "string" ? msg : msg();
        if (options === null || options === void 0 ? void 0 : options.installLogger) {
            logNodeOnlyLogger = options.installLogger;
        }
        const level = (_a = options === null || options === void 0 ? void 0 : options.level) !== null && _a !== void 0 ? _a : "info";
        if (logNodeOnlyLogger) {
            logNodeOnlyLogger(msg, level);
        }
        else {
            (level === "warn" ? console.warn : console.log)(`[logNodeOnly][${level}] ` + msg);
        }
    }
}
exports.logNodeOnly = logNodeOnly;
/**
 * Extracts the user's device information using the userAgent
 * TODO: delete once using DetectDevice API instead
 */
function getDeviceInfoFromUserAgent(userAgent = navigator.userAgent) {
    var _a, _b, _c, _d, _e;
    const deviceInformation = new device_detector_js_1.default().parse(userAgent);
    return {
        device: {
            manufacturer: (_a = deviceInformation.device) === null || _a === void 0 ? void 0 : _a.brand,
            model: (_b = deviceInformation.device) === null || _b === void 0 ? void 0 : _b.model,
            type: (_c = deviceInformation.device) === null || _c === void 0 ? void 0 : _c.type,
        },
        os: { name: (_d = deviceInformation.os) === null || _d === void 0 ? void 0 : _d.name, version: (_e = deviceInformation.os) === null || _e === void 0 ? void 0 : _e.version },
        screen: isRunningInNode()
            ? {}
            : { density: window.devicePixelRatio || 1, height: screen.height, width: screen.width },
    };
}
exports.getDeviceInfoFromUserAgent = getDeviceInfoFromUserAgent;
function fireAndForgetWrapper(fn, onError = () => { }) {
    void fn().catch((err) => {
        onError(err);
    });
}
exports.fireAndForgetWrapper = fireAndForgetWrapper;
/**
 * @description used to satisfy `@typescript-eslint/no-misused-promises`. Intended to be wrapped around event handlers
 * @example
 *   const handler = async (something) => { await do(something); }
 *   eventEmitter.on("event", createVoidHandler(handler));
 */
const createVoidHandler = (handler) => (...args) => void handler(...args).catch(() => {
    /* noop */
});
exports.createVoidHandler = createVoidHandler;
/**
 * Times how long it takes for a certain function to run
 */
function getTimeDuration(fn) {
    return __awaiter(this, void 0, void 0, function* () {
        const start = ZonedDateTime_1.ZonedDateTime.now();
        const result = yield fn();
        return { result, duration: start.elapsed() };
    });
}
exports.getTimeDuration = getTimeDuration;
//# sourceMappingURL=Utils.js.map